import { MarketCredit } from '@sorare/core/src/atoms/icons/MarketCredit';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { ToggleFilter } from '#src/searchCards/ToggleFilter/index.tsx';

const FILTER = TOGGLE_FILTERS.creditEligibleFilter;

export const widget = ({
  startsOpen = true,
}: {
  startsOpen?: boolean;
} = {}): FilterWidget => ({
  key: FILTER.attribute,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: () => (
    <ToggleFilter
      icon={<MarketCredit width={24} height={24} />}
      filter={FILTER}
      on={['PrimaryOffer', 'EnglishAuction']}
    />
  ),
  accordionOptions: { startsOpen },
});
